enum Bases {
  LOCAL = "local",
  HOMOLOG = "homolog",
  PROD = "prod",
}

let BASE: Bases = Bases.HOMOLOG;

const currentDomain = window.location.href;

if (currentDomain.includes("devaribox.co")) {
  BASE = Bases.HOMOLOG;
} else if (currentDomain.includes("devari.com")) {
  BASE = Bases.PROD;
} else {
  BASE = Bases.LOCAL;
}

let CURRENT_STORE = "b3x";

if (currentDomain.includes("gmdimensional")) {
  CURRENT_STORE = "gmdimensional";
} else if (currentDomain.includes("b3x")) {
  CURRENT_STORE = "b3x";
}

export { BASE, CURRENT_STORE };
